import React from 'react';
import ButtonCreate from '../../components/actions/ButtonCreate';
import BaseMenu from '../../components/navigation/BaseMenu';
import { UserMenu } from '../../components/user-menu';
import { InfoMenu } from '../../components/info-menu';
import { Variant } from '../types';

const analyze: Variant = {
  brand: 'SurveyMonkey',
  getMenuItems: (experiment): JSX.Element[] => {
    return [<BaseMenu key="base-menu" experiment={experiment} />];
  },
  actions: [<ButtonCreate key="action-create" />],
  info: [<InfoMenu key="menu-info" />],
  user: [<UserMenu key="menu-user" />],
  homePage: '/',
};

export default analyze;
